import React from 'react';
import './Gold.css';
import icon1 from '../../../assets/IconsTrusted-by-traders-across-Dubai.png';
import icon2 from '../../../assets/IconsTransparent-fees-&-real-time-market-access.png';
import icon3 from '../../../assets/IconsFully-secure-platform.png';
import icon4 from '../../../assets/Icons-Backed-by-professional-support.png';


const translations = {
  en: {
    heroSubtitle: "Gold is rising—Now is your moment!",
    heroTitle: "Capitalize on gold’s historic surge with ",
    heroDescription: "Trade gold in just a few steps",
    heroButton: "Trade gold now",
    sectionTitle: "Gold is hitting numbers we haven’t seen before. Every second you hesitate is a missed opportunity to capitalize on gold's historic climb.",
    sectionDescription: "GivTrade makes gold trading easy, fast, and rewarding. With competitive spreads, 24/7 support, and secure withdrawals, you’ll trade with total security.",
    whyTitle: "Why trade gold with GivTrade?",
    benefits: [
      { title: "Spreads starting at 0.0 Pip", description: "Get the most out of every trade with tighter spreads." },
      { title: "Fast & Safe Deposits and Withdrawals", description: "No delays, no worries—your funds are always within reach." },
      { title: "Easy Account Opening", description: "Get started in minutes." },
      { title: "24/7 Support", description: "Support whenever you need it—24/7, we’re here for you." },
      { title: "Competitive Commissions", description: "Get the most out of every trade with minimal costs." },
      { title: "Trade from Anywhere, Anytime", description: "Trade gold on your terms, from your phone or desktop with GivTrade." },
    ],
    ctaTitle: "Get started",
    ctaDescription: "Open your account instantly.",
    ctaBenefits: [
      "Trusted by traders across Dubai",
      "Fully secure platform",
      "Transparent fees & real-time market access",
      "Backed by professional support",
    ],
    ctaButton: "Open Your Account",
  },
  ar: {
    heroSubtitle: "الذهب يرتفع - الآن فرصتك!",
    heroTitle: "استفد من الارتفاع التاريخي للذهب مع ",
    heroDescription: "تداول الذهب بخطوات بسيطة",
    heroButton: "ابدأ تداول الذهب الآن",
    sectionTitle: "الذهب يحقق أرقاماً غير مسبوقة. كل ثانية تتردد فيها هي فرصة ضائعة للاستفادة من هذا الارتفاع التاريخي.",
    sectionDescription: "تداول الذهب مع GivTrade أصبح سهلاً وسريعاً ومجزياً. مع فروق أسعار تنافسية ودعم 24/7 وسحوبات آمنة، ستتداول بثقة كاملة.",
    whyTitle: "لماذا تتداول الذهب مع GivTrade؟",
    benefits: [
      { title: "فروقات تبدأ من 0.0 نقطة", description: "احصل على أفضل قيمة من كل صفقة مع فروقات أسعار أقل." },
      { title: "إيداعات وسحوبات سريعة وآمنة", description: "لا تأخير، لا قلق - أموالك دائماً في متناول يدك." },
      { title: "فتح حساب بسهولة", description: "ابدأ خلال دقائق معدودة." },
      { title: "دعم متوفر على مدار الساعة", description: "دعم متاح دائماً عند الحاجة - 24/7." },
      { title: "عمولات تنافسية", description: "احصل على أقصى استفادة بأقل التكاليف." },
      { title: "تداول من أي مكان وفي أي وقت", description: "تداول الذهب بالشكل الذي يناسبك عبر الجوال أو الكمبيوتر." },
    ],
    ctaTitle: "ابدأ الآن",
    ctaDescription: "افتح حسابك فوراً.",
    ctaBenefits: [
      "موثوق من قبل المتداولين في دبي",
      "منصة آمنة بالكامل",
      "رسوم شفافة ووصول فوري للأسواق",
      "مدعوم بفريق دعم محترف",
    ],
    ctaButton: "افتح حسابك",
  },
};

const Gold = ({ language = 'en' }) => {
    const t = translations[language];

  return (
    <div className='full'>
      <div className='forex-container font-sans text-white'>
        {/* HERO SECTION */}
        <div className="hero-section-gold">
          <div className="hero-overlay" />
          <div className="hero-content">
            <p className="hero-subtitle">{t.heroSubtitle}</p>
            <h1 className="hero-title">
              {t.heroTitle}
              <span className="highlight">GivTrade</span>
            </h1>
            <p className="hero-description">{t.heroDescription}</p>
            <button
              className="hero-button"
              onClick={() => window.open('https://accounts.giv.trade/marketing/links/go/6', '_blank')}
            >
              {t.heroButton}
            </button>
          </div>
        </div>

        {/* SECTION 2 */}
        <section className='section py-10'>
          <p className='section-title'>{t.sectionTitle}</p>
          <p className='section-description'>{t.sectionDescription}</p>
        </section>

        {/* SECTION 3 */}
        <section className='section component-data-container py-16 grid md:grid-cols-2 gap-12 bg-black px-4'>
          <div>
            <h2 className='section-heading'>{t.whyTitle}</h2>
            <ul className='benefits-list'>
              {t.benefits.map((item, index) => (
                <li key={index}>
                  <strong className='benefit-title'>{item.title}</strong>
                  <p>{item.description}</p>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className='section'>
          <div className='cta-box text-center'>
            <h3 className='cta-title'>{t.ctaTitle}</h3>
            <p className='cta-description'>{t.ctaDescription}</p>
            <ul className='cta-benefits'>
              {t.ctaBenefits.map((benefit, index) => (
                <li key={index} className='cta-lable flex flex-col items-center gap-1 text-center'>
                  <img src={[icon1, icon3, icon2, icon4][index]} alt='Check' className='icon' />
                  {benefit}
                </li>
              ))}
            </ul>
            <button
              className='cta-button mx-auto block'
              onClick={() => window.open('https://accounts.giv.trade/marketing/links/go/6', '_blank')}
            >
              {t.ctaButton}
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Gold;
